// extracted by css-extract-rspack-plugin
export default {"cls1":"ChurnedUserReactivationButton-cls1_YJa","cls2":"ChurnedUserReactivationButton-cls2_o4H ChurnedUserReactivationButton-cls1_YJa"};